import {
  formatAssignmentDateTime,
  formatComplaintDateTime,
} from "./ComplaintStore/useComplaintStore";

export const COMPLAINT_EXPORT_COLUMNS = [
  "S.No",
  "CG No",
  "Complainant Name",
  "Contact No",
  "Complaint Type",
  "Complaint Category",
  "Description",
  "Zone",
  "Ward No",
  "Street Location",
  "Complaint Created On",
  "Complaint Closure On",
  "Mode Of Reporting",
  "Predefined SLA Duration (Min)",
  "Actual Duration (Hr:Min)",
  "Status",
  "Close Time Location",
  "Action Remarks",
  "Revised Ward No",
  "Revised Street Location",
];

export const COMPLAINT_HISTORY_COLUMNS = [
  "S.No",
  "Assigned To",
  "Status",
  "Action Remarks",
  "Assigned On",
  "Action Taken On",
  "Total Time (Hr:Min)",
  "Assigned By",
];

export const mapComplaintRowsForExport = (complaintData = []) =>
  (complaintData ?? []).map((row, index) => [
    index + 1,
    row.cgNo || "N/A",
    row.complainantName || "N/A",
    row.contactNo || "N/A",
    row.complaintType || "N/A",
    row.complaintCategory || "N/A",
    row.description || "N/A",
    row.zoneName || "N/A",
    row.wardNo || "N/A",
    row.colonyName || "N/A",
    formatComplaintDateTime(row.complaintCreatedOn),
    formatComplaintDateTime(row.complaintClosureOn),
    row.modeOfReporting || "N/A",
    row.predefinedSlaDurationMin || "N/A",
    row.actualDuration || "N/A",
    row.status || "N/A",
    row.closeTimeLatitude && row.closeTimeLongitude
      ? `${row.closeTimeLatitude}, ${row.closeTimeLongitude}`
      : "N/A",
    row.actionRemarks || "N/A",
    row.revisedWardNo || "N/A",
    row.revisedStreetLocation || "N/A",
  ]);

export const getHistoryForRow = (row, historyById = {}) => {
  const id = row?.complaintId;
  if (!id) return [];
  return historyById[id.toString()] || [];
};

export const mapHistoryRowsForExport = (history = []) =>
  (history ?? []).map((item, index) => [
    index + 1,
    item.assignedTo || "N/A",
    item.status || "N/A",
    item.actionRemarks || "N/A",
    formatAssignmentDateTime(item.assignedOn),
    formatAssignmentDateTime(item.actionTakenOn),
    item.totalTime || "N/A",
    item.assignedBy || "N/A",
  ]);

export const loadAllComplaintHistory = async (
  complaintData = [],
  fetchComplaintAssignedDetails
) => {
  const historyById = {};

  await Promise.all(
    (complaintData ?? []).map(async (row) => {
      const id = row?.complaintId;
      if (!id) return;

      try {
        const data = await fetchComplaintAssignedDetails(id);
        historyById[id.toString()] = Array.isArray(data) ? data : [];
      } catch {
        historyById[id.toString()] = [];
      }
    })
  );

  return historyById;
};

export const getExportDateTime = () => {
  const now = new Date();
  const date = `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}`;
  const time = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
  return `Complaint List Generated on: ${date}, ${time}`;
};
